<template>
  <div>
    <!-- 标题栏 -->
    <div class="searchBox">
      <div>
        <el-input v-model="keyword" placeholder="订单号" style="width: 200px" size="small" clearable></el-input>
        <el-input v-model="keyword2" placeholder="货号" style="width: 200px;margin-left: 5px;" size="small" clearable></el-input>
        <el-input v-model="keyword3" placeholder="产品规格" style="width: 200px;margin-left: 5px;" size="small" clearable></el-input>
        <el-input v-model="keyword4" placeholder="颜色" style="width: 200px;margin-left: 5px;" size="small" clearable></el-input>
        <el-button type="primary" size="small" style="margin-left: 10px" @click="search"><i class="el-icon-search" style="margin-right: 5px"></i>搜索</el-button>
        <el-button size="small" @click="reset"><i class="el-icon-refresh-left" style="margin-right: 5px"></i>重置</el-button>
        <div style="margin-top: 10px;">
          <el-date-picker v-model="today" type="date" placeholder="选择日期" @change="search"
            :clearable="false" :editable="false"></el-date-picker>
        </div>
      </div>
      <div>
        <el-button type="success" size="small" style="margin-left: 10px" @click="add"><i class="el-icon-plus" style="margin-right: 5px"></i>新增</el-button>
      </div>
    </div>

    <div class="mainBox" style="display: flex; padding: 0; height: 100%">
      <div style="width: calc(100%); padding: 20px; height: calc(100vh - 50px - 113px)" v-loading="listLoading">
        <el-table :data="list" element-loading-text="Loading" fit highlight-current-row border height="calc(100% - 72px)" style="width: 100%">
          <el-table-column align="center" label="日期" min-width="100" prop="riqi"></el-table-column>
          <el-table-column align="center" label="客户" min-width="100" prop="kehu"></el-table-column>
          <el-table-column align="center" label="订单号" min-width="100" prop="dingdanhao"></el-table-column>
          <el-table-column align="center" label="货号" min-width="100" prop="huohao"></el-table-column>
          <el-table-column align="center" label="产品规格" min-width="100" prop="chanpinguige"></el-table-column>
          <el-table-column align="center" label="订单数量" min-width="100" prop="dingdanshuliang"></el-table-column>
          <el-table-column align="center" label="颜色" min-width="100" prop="yanse"></el-table-column>
          <el-table-column align="center" label="物料名称" min-width="100" prop="wuliaomingcheng"></el-table-column>
          <el-table-column align="center" label="物料规格" min-width="100" prop="wuliaoguige"></el-table-column>
          <el-table-column align="center" label="材质" min-width="100" prop="caizhi"></el-table-column>
          <el-table-column align="center" label="单伞用量" min-width="100" prop="dansanyongliang"></el-table-column>
          
          <el-table-column align="center" label="当日外协/库存" min-width="150" prop="kucun"></el-table-column>
          <el-table-column align="center" label="产量普工一线白班" min-width="100" prop="chanliang1"></el-table-column>
          <el-table-column align="center" label="产量普工一线白班1" min-width="100" prop="chanliang11"></el-table-column>
          <el-table-column align="center" label="产量普工二线白班" min-width="100" prop="chanliang2"></el-table-column>
          <el-table-column align="center" label="产量普工二线白班1" min-width="100" prop="chanliang21"></el-table-column>
          <el-table-column align="center" label="产量普工三线白班" min-width="100" prop="chanliang3"></el-table-column>
          <el-table-column align="center" label="产量普工四线白班" min-width="100" prop="chanliang4"></el-table-column>
          <el-table-column align="center" label="产量普工四线白班1" min-width="100" prop="chanliang41"></el-table-column>
          <el-table-column align="center" label="产量普工三线白班" min-width="100" prop="chanliang5"></el-table-column>
          <el-table-column align="center" label="产量普工三线白班1" min-width="100" prop="chanliang6"></el-table-column>
          <el-table-column align="center" label="产量普工一线夜班" min-width="100" prop="chanliang7"></el-table-column>
          <el-table-column align="center" label="产量普工一线夜班1" min-width="100" prop="chanliang8"></el-table-column>
          <el-table-column align="center" label="产量其他" min-width="100" prop="chanliang9"></el-table-column>
          <el-table-column align="center" label="单根工价普工" min-width="100" prop="danjiapugong"></el-table-column>
          <el-table-column align="center" label="单根工价枪手" min-width="100" prop="danjiaqiangshou"></el-table-column>
          <el-table-column align="center" label="期初外协/库存" min-width="100" prop="qichukucun"></el-table-column>
          <el-table-column align="center" label="期初产量" min-width="100" prop="qichuchanliang"></el-table-column>
          
          <el-table-column align="center" label="操作" width="120" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" @click="edit(scope.row.id)">编辑</el-button>
              <el-button type="text" @click="del(scope.row.id)" style="color: #f56c6c">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="padding: 20px; text-align: center">
          <el-pagination
            background
            layout="total, sizes,prev, pager, next, jumper"
            @size-change="pageSizeChange"
            :total="total"
            @current-change="pageChange"
            :current-page="pageNum"
            :page-size="pageSize"
          >
          </el-pagination>
        </div>
      </div>
    </div>

    <!-- 添加修改弹窗 -->
    <el-dialog title="编辑" :visible.sync="editModal">
      <el-form :model="editForm" ref="EditForm" label-width="150px" :rules="rules">
        <el-form-item label="日期" prop="riqi">
          <el-date-picker v-model="editForm.riqi" value-format="timestamp"
            type="date" placeholder="选择日期"></el-date-picker>
        </el-form-item>
        
        <el-form-item label="客户" prop="kehu">
          <el-select v-model="orderValue" filterable placeholder="请选择"
            @change="orderChange" style="width: 600px;">
            <el-option v-for="item in orderSelectList"
              :key="item.kehu+'_'+item.dingdanhao+'_'+item.huohao+'_'+item.chanpinguige+'_'+item.yanse+'_'+item.dingdanshuliang"
              :label="item.kehu+'_'+item.dingdanhao+'_'+item.huohao+'_'+item.chanpinguige+'_'+item.yanse+'_'+item.dingdanshuliang"
              :value="item.kehu+'_'+item.dingdanhao+'_'+item.huohao+'_'+item.chanpinguige+'_'+item.yanse+'_'+item.dingdanshuliang">
            </el-option>
          </el-select>
          <el-input v-model="editForm.kehu" style="margin-right: 10px;"></el-input>
        </el-form-item>
        <el-form-item label="订单号" prop="dingdanhao">
          <el-input v-model="editForm.dingdanhao"></el-input>
        </el-form-item>
        <el-form-item label="货号" prop="huohao">
          <el-input v-model="editForm.huohao"></el-input>
        </el-form-item>
        <el-form-item label="产品规格" prop="chanpinguige">
          <el-input v-model="editForm.chanpinguige"></el-input>
        </el-form-item>
        <el-form-item label="订单数量" prop="dingdanshuliang">
          <el-input-number v-model="editForm.dingdanshuliang" :precision="5" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
        <el-form-item label="颜色" prop="yanse">
          <el-input v-model="editForm.yanse"></el-input>
        </el-form-item>
        <el-form-item label="物料名称" prop="wuliaomingcheng">
          <div style="display: flex;">
            <el-input v-model="editForm.wuliaomingcheng" style="margin-right: 10px;"></el-input>
            <el-select v-model="gongxuValue" filterable placeholder="请选择" style="width: 400px;"
              @change="gongxuChange" >
              <el-option v-for="(item,index) in gongxuSelectList"
                :key="index" :label="item.wuliaomingcheng" 
                :value="item.wuliaomingcheng">
              </el-option>
            </el-select>
          </div>
        </el-form-item>
        <el-form-item label="物料规格" prop="wuliaoguige">
          <el-input v-model="editForm.wuliaoguige"></el-input>
        </el-form-item>
        <el-form-item label="材质" prop="caizhi">
          <el-input v-model="editForm.caizhi"></el-input>
        </el-form-item>
        <el-form-item label="单伞用量" prop="dansanyongliang">
          <el-input-number v-model="editForm.dansanyongliang" :precision="0" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
        
        <el-form-item label="外协/库存" prop="kucun">
          <el-input-number v-model="editForm.kucun" :precision="5" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
        <div class="chanliangWrap">
          <el-form-item label="产量普工一线白班" prop="chanliang1">
            <el-input-number v-model="editForm.chanliang1" :precision="5" :step="1" :max="100000000"></el-input-number>
          </el-form-item>
          <el-form-item label="产量普工一线白班1" prop="chanliang11">
            <el-input-number v-model="editForm.chanliang11" :precision="5" :step="1" :max="100000000"></el-input-number>
          </el-form-item>
        </div>
        <div class="chanliangWrap">
          <el-form-item label="产量普工二线白班" prop="chanliang2">
            <el-input-number v-model="editForm.chanliang2" :precision="5" :step="1" :max="100000000"></el-input-number>
          </el-form-item>
          <el-form-item label="产量普工二线白班1" prop="chanliang21">
            <el-input-number v-model="editForm.chanliang21" :precision="5" :step="1" :max="100000000"></el-input-number>
          </el-form-item>
        </div>
        <el-form-item label="产量普工三线白班" prop="chanliang3">
          <el-input-number v-model="editForm.chanliang3" :precision="5" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
        <div class="chanliangWrap">
          <el-form-item label="产量普工四线白班" prop="chanliang4">
            <el-input-number v-model="editForm.chanliang4" :precision="5" :step="1" :max="100000000"></el-input-number>
          </el-form-item>
          <el-form-item label="产量普工四线白班1" prop="chanliang41">
            <el-input-number v-model="editForm.chanliang41" :precision="5" :step="1" :max="100000000"></el-input-number>
          </el-form-item>
        </div>
        <div class="chanliangWrap">
          <el-form-item label="产量普工三线白班" prop="chanliang5">
            <el-input-number v-model="editForm.chanliang5" :precision="5" :step="1" :max="100000000"></el-input-number>
          </el-form-item>
          <el-form-item label="产量普工三线白班1" prop="chanliang6">
            <el-input-number v-model="editForm.chanliang6" :precision="5" :step="1" :max="100000000"></el-input-number>
          </el-form-item>
        </div>
        <div class="chanliangWrap">
          <el-form-item label="产量普工一线夜班" prop="chanliang7">
            <el-input-number v-model="editForm.chanliang7" :precision="5" :step="1" :max="100000000"></el-input-number>
          </el-form-item>
          <el-form-item label="产量普工一线夜班1" prop="chanliang8">
            <el-input-number v-model="editForm.chanliang8" :precision="5" :step="1" :max="100000000"></el-input-number>
          </el-form-item>
        </div>
        
        <el-form-item label="产量其他" prop="chanliang9">
          <el-input-number v-model="editForm.chanliang9" :precision="5" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
        <el-form-item label="单根工价普工" prop="danjiapugong">
          <el-input-number v-model="editForm.danjiapugong" :precision="5" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
        <el-form-item label="单根工价枪手" prop="danjiaqiangshou">
          <el-input-number v-model="editForm.danjiaqiangshou" :precision="5" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
        <el-form-item label="期初外协/库存" prop="qichukucun">
          <el-input-number v-model="editForm.qichukucun" :precision="5" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
        <el-form-item label="期初产量" prop="qichuchanliang">
          <el-input-number v-model="editForm.qichuchanliang" :precision="5" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
        
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editModal = false">取 消</el-button>
        <el-button type="primary" @click="save">确 定</el-button>
      </div>
    </el-dialog>
    
  </div>
</template>

<script>
// 产量顺序
//普工一线白班,普工二线白班,普工三线白班,普工四线白班,普工三线白班,普工三线白班1,普工一线夜班,普工一线夜班,其他
const editFormData = () => {
  return {
    riqi: '',
    
    kehu: "",
    dingdanhao: "",
    huohao: "",
    chanpinguige: "",
    dingdanshuliang: 0,
    yanse: "",
    
    wuliaomingcheng: "",
    wuliaoguige: "",
    caizhi: "",
    dansanyongliang: 0,
    
    kucun: 0,
    chanliang1: 0,
    chanliang11: 0,
    chanliang2: 0,
    chanliang21: 0,
    chanliang3: 0,
    chanliang4: 0,
    chanliang41: 0,
    chanliang5: 0,
    chanliang6: 0,
    chanliang7: 0,
    chanliang8: 0,
    chanliang9: 0,
    danjiapugong: 0,
    danjiaqiangshou: 0,
    
    qichukucun: 0,
    qichuchanliang: 0,
  }
}
export default {
  data() {
    return {
      url: this.$host,
      list: null,
      pageNum: 1,
      pageSize: 20,
      total: 0,
      listLoading: true,
      keyword: "",
      keyword2: "",
      keyword3: "",
      keyword4: "",
      keywordType: 1,
      editModal: false,
      editForm: editFormData(),
      rules: {
        
      },
      sf: '',
      orderSelectList: [],
      memberSelectList: [],
      gongxuSelectList: [],
      orderValue: '',
      gongxuValue: '',
      today: '',
    }
  },

  created() {
    this.sf = localStorage.sf
    this.getList()
    this.getSelectList()
  },

  methods: {
    orderChange(e) {
      let arr = e.split('_')
      for(let i in this.orderSelectList) {
        if(this.orderSelectList[i].kehu==arr[0]&&
        this.orderSelectList[i].dingdanhao==arr[1]&&
        this.orderSelectList[i].huohao==arr[2]&&
        this.orderSelectList[i].chanpinguige==arr[3]&&
        this.orderSelectList[i].yanse==arr[4]&&
        this.orderSelectList[i].dingdanshuliang==arr[5]) {
          this.editForm.kehu = this.orderSelectList[i].kehu;
          this.editForm.dingdanhao = this.orderSelectList[i].dingdanhao;
          this.editForm.huohao = this.orderSelectList[i].huohao;
          this.editForm.chanpinguige = this.orderSelectList[i].chanpinguige;
          this.editForm.dingdanshuliang = this.orderSelectList[i].dingdanshuliang;
          this.editForm.yanse = this.orderSelectList[i].yanse;
          
          this.gongxuValue = ''
          this.editForm.wuliaomingcheng = '';
          this.editForm.wuliaoguige = '';
          this.editForm.caizhi = '';
          this.editForm.dansanyongliang = 0;
          this.editForm.danjiapugong = 0;
          this.editForm.danjiaqiangshou = 0;
          
          if(this.orderSelectList[i].gongxuArr) {
            this.gongxuSelectList = JSON.parse(this.orderSelectList[i].gongxuArr)
          }else{
            this.gongxuSelectList = []
          }
        }
      }
    },
    
    gongxuChange(e) {
      for(let i in this.gongxuSelectList) {
        if(this.gongxuSelectList[i].wuliaomingcheng==e) {
          this.editForm.wuliaomingcheng = this.gongxuSelectList[i].wuliaomingcheng;
          this.editForm.wuliaoguige = this.gongxuSelectList[i].wuliaoguige;
          this.editForm.caizhi = this.gongxuSelectList[i].caizhi;
          this.editForm.dansanyongliang = this.gongxuSelectList[i].dansanyongliang;
          this.editForm.danjiapugong = this.gongxuSelectList[i].danjiapugong;
          this.editForm.danjiaqiangshou = this.gongxuSelectList[i].danjiaqiangshou;
        }
      }
    },
    
    getSelectList() {
      this.$request.post('/index.php/admin/ordermodel/tuzhuangliangtingMbSelect').then((res) => {
        this.orderSelectList = res.data.data
      }).catch(err => {
        console.log(err)
      })
    },
    
    getMemberSelectList() {
      this.$request.post('/index.php/admin/admin/memberSelect').then((res) => {
        this.memberSelectList = res.data.data
      }).catch(err => {
        console.log(err)
      })
    },
    
    search() {
      this.pageNum = 1
      this.getList()
    },
    
    reset() {
      this.keyword = ""
      this.keyword2 = ""
      this.keyword3 = ""
      this.keyword4 = ""
      this.today = ''
      this.search()
    },
    
    add() {
      let form = JSON.parse(JSON.stringify(this.editForm))
      this.editForm = JSON.parse(JSON.stringify(editFormData()))
      if(form.kehu) {
        this.editForm.kehu = form.kehu;
        this.editForm.dingdanhao = form.dingdanhao;
        this.editForm.huohao = form.huohao;
        this.editForm.chanpinguige = form.chanpinguige;
        this.editForm.dingdanshuliang = form.dingdanshuliang;
        this.editForm.yanse = form.yanse;
      }
      if(form.wuliaomingcheng) {
        this.editForm.wuliaomingcheng = form.wuliaomingcheng;
        this.editForm.wuliaoguige = form.wuliaoguige;
        this.editForm.caizhi = form.caizhi;
        this.editForm.dansanyongliang = form.dansanyongliang;
        this.editForm.danjiapugong = form.danjiapugong;
        this.editForm.danjiaqiangshou = form.danjiaqiangshou;
      }
      
      this.editModal = true
    },

    edit(id) {
      this.$request.post('/index.php/admin/orderform/tuzhuangliangtingInfo', {id: id}).then((res) => {
        this.editForm = res.data.data
        this.editForm.riqi = parseInt(this.editForm.riqi*1000)
        this.editModal = true
      }).catch(err => {
        console.log(err)
      })
    },

    del(id) {
      this.$confirm("请确认是否删除该条信息?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$request.post('/index.php/admin/orderform/tuzhuangliangtingDel', {id: id}).then((res) => {
          this.$message.success(res.data.msg)
          this.getList()
        }).catch(err => {
          console.log(err)
        })
      })
    },

    save() {
      this.$refs["EditForm"].validate((valid) => {
        if (valid) {
          let data = JSON.parse(JSON.stringify(this.editForm))
          data.riqi = parseInt(data.riqi/1000)
          data.account = localStorage.account
          this.$request.post('/index.php/admin/orderform/tuzhuangliangtingSave', data).then((res) => {
            if(res.data.code==200) {
              this.$message.success(res.data.msg)
              this.editModal = false
              this.getList()
            }else{
              this.$message.error(res.data.msg)
            }
          }).catch(err => {
            console.log(err)
          })
        }
      })
    },


    pageChange(page) {
      this.pageNum = page
      this.getList()
    },

    pageSizeChange(size) {
      this.pageSize = size
      this.getList()
    },

    getList() {
      this.listLoading = true
      let data = {
        page: this.pageNum,
        num: this.pageSize,
      }
      if(this.keyword) {
        data.keyword = this.keyword
      }
      if(this.keyword2) {
        data.keyword2 = this.keyword2
      }
      if(this.keyword3) {
        data.keyword3 = this.keyword3
      }
      if(this.keyword4) {
        data.keyword4 = this.keyword4
      }
      if(this.today) {
        data.year = this.today.getFullYear()
        data.month = this.today.getMonth()+1
        data.day = this.today.getDate()
      }
      this.$request.post('/index.php/admin/orderform/tuzhuangliangtingList', data).then((res) => {
        this.list = res.data.data
        this.total = res.data.count
        this.listLoading = false
      }).catch(err => {
        console.log(err)
      })
    },
  },
}
</script>
<style scoped="">
.chanliangWrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 100px;
}
</style>
